var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControlsIconFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls-icon-Filter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2313",
    "data-name": "Rectangle 2313",
    width: 38,
    height: 38,
    fill: "#009AD9",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    "data-name": "Path 3767",
    d: "M34.382,48.68a1.349,1.349,0,0,1-.974-.416L27.33,41.928a1.363,1.363,0,0,1-.377-.942V28.261L13.739,14.994a1.356,1.356,0,0,1,.955-2.314h33.3a1.355,1.355,0,0,1,.955,2.314L35.733,28.261V47.324a1.355,1.355,0,0,1-.846,1.257A1.323,1.323,0,0,1,34.382,48.68Zm-4.728-8.24,3.377,3.52V27.7a1.356,1.356,0,0,1,.4-.959l11.3-11.348H17.954l11.3,11.348a1.358,1.358,0,0,1,.4.959Z",
    transform: "translate(-12.343 -11.68)",
    fill: "#009AD9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsIconFilter);
export default __webpack_public_path__ + "static/media/Controls-icon-Filter.7d9e13e60356a960c926bbb594adbcde.svg";
export { ForwardRef as ReactComponent };